const PREGUNTAS = [
  {
    pregunta: '¿Cómo pago mi pedido?',
    respuesta:
      'Al finalizar tu compra, te redirigimos a WhatsApp con el resumen de tu pedido. Ahí coordinamos el pago por transferencia, Yape, Plin o efectivo contra entrega, según lo que prefieras.',
  },
  {
    pregunta: '¿Necesito crear una cuenta para comprar?',
    respuesta: 'No. Puedes armar tu carrito y finalizar tu compra sin registrarte.',
  },
  {
    pregunta: '¿Tienen precios especiales por cantidad?',
    respuesta:
      'Sí. Muchos productos ofrecen paquetes por docena, media docena o ciento con mejor precio por unidad — los verás al elegir el producto.',
  },
  {
    pregunta: '¿A qué zonas hacen envíos?',
    respuesta: 'Coordinamos envíos a todo el Perú. Los detalles se acuerdan directamente por WhatsApp.',
  },
];

export function FAQPage() {
  return (
    <section className="px-4 sm:px-6 md:px-14 py-10 md:py-16 max-w-2xl mx-auto flex flex-col gap-8">
      <h1 className="text-4xl font-display font-semibold text-wood">Preguntas Frecuentes</h1>
      <div className="flex flex-col gap-6">
        {PREGUNTAS.map((item) => (
          <div key={item.pregunta} className="flex flex-col gap-1.5">
            <div className="text-[15px] font-semibold text-ink">{item.pregunta}</div>
            <div className="text-[14px] leading-relaxed text-ink-muted">{item.respuesta}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
